<template>
    <div class="bg_white">
        <van-nav-bar
        title="在线培训"
        left-text=""
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
        >
        <template #right>
          <van-icon name="wap-home-o" size="20" />
        </template>
        </van-nav-bar>
        <div v-for="(item,index) in list" :key="index">
          <div class="course_list" @click="goDetail(item.sysCourseProject)">
          <div class="flex course_box" href="/vedioDetail">
            <img src="../../asset/images/course.png">
            <div class="course_content">
              <h3>{{item.sysCourseProject.name}}</h3>
              <p>总时长：{{getTime(item.durationTime)}}</p>
              <p>总学时：{{getstudytime(item.durationTime)}}个</p>
            </div>
            <van-icon name="arrow"/>
          </div>
          <van-divider />
        </div>
        
        </div>

        
        
    </div>
</template>

<script>
import { getCourseList } from '../../api/course';
export default {
  data() {
    return {
        list:[],
        
    }

   },
   mounted(){
    this.getlist()
   },
   methods: {
    getTime(time) {
      let h = parseInt(time / 60 / 60 )
      h = h < 10 ? '0' + h : h
      let m = parseInt(time / 60 % 60)
      m = m < 10 ? '0' + m : m
      let s = parseInt(time % 60)
      s = s < 10 ? '0' + s : s
      return h + ":" + m + ":" + s
    },
    
    getstudytime(time){
      //转换成30小时学时
      return (time / 60 / 30).toFixed(1)

    },
    
    // getTime(time){
    //     // 转换为式分秒
    //         let h = parseInt(time / 60 / 60 % 24)
    //         h = h < 10 ? '0' + h : h
    //         let m = parseInt(time / 60 % 60)
    //          m = m < 10 ? '0' + m : m
    //         let s = parseInt(time % 60)
    //          s = s < 10 ? '0' + s : s
    //     // 作为返回值返回
    //         return h+":"+m+":"+s
    // },
    getlist(){
      let that=this
      getCourseList().then(res=>{
        that.list =res.data.list
      })
    },
    goDetail(project){
      const detailPath = this.getCourseDetailPath(project.id)
      if(project.checkFace==1){
        this.$dialog.alert({
                    message: "平台已开启在线学习随机人脸验证，请确保您已经绑定身份证，且上传2寸证件照，并完成报名建档！",
                    theme: 'round-button',
                    confirmButtonText:'确定'
         }).then(()=>{
          this.$router.push(detailPath)
         })
      }else{
        this.$router.push(detailPath)
      }
      
    },
    getCourseDetailPath(projectId){
      const userAgent = window.navigator.userAgent || ''
      const isHarmony = /HarmonyOS|OpenHarmony|ArkWeb/i.test(userAgent)
      console.log('课程详情系统判断', userAgent, isHarmony ? '鸿蒙系统' : '非鸿蒙系统')
      return (isHarmony ? '/courseDetailHarmous?id=' : '/courseDetail?id=') + projectId
    },
    onClickLeft() {
      this.$router.back()
    },
    onClickRight() {
      this.$router.push("/home")
    },
  }

};
</script>

<style lang="less">
  .course_list{
    width: 100%;
    overflow: hidden;
    padding: 15px;
    box-sizing: border-box;
  }
.course_box{
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  img{
    // width: 33%;
    width: 115px;
    height: 71px;
    border-radius: 5px;
  }
  .course_content{
    width: 50%;
  }

}


</style>

